import { c as _c } from "react/compiler-runtime";
import { formatRatio, formatWeightValue } from '@/lib/format/format-weight';
export interface AnalyzeDataSheetTableCellProps {
  /** Ratios carry two decimals and no unit. */
  isRatio?: boolean;
  locale: string;
  value: number | null;
}

/**
 * One figure of the sheet.
 *
 * The unit is in the column header, not in the cell: a column of numbers is
 * read by comparing their digits, which a repeated `g` only gets in the way of.
 */
export const AnalyzeDataSheetTableCell: React.FC<AnalyzeDataSheetTableCellProps> = t0 => {
  const $ = _c(6);
  const {
    isRatio,
    locale,
    value
  } = t0;
  let t1;
  if ($[0] !== isRatio || $[1] !== locale || $[2] !== value) {
    t1 = isRatio ? formatRatio(value, locale) : formatWeightValue(value, locale);
    $[0] = isRatio;
    $[1] = locale;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <td className="px-2 py-[7px] text-right font-mono text-[13px] tabular-nums">{t1}</td>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};